<template>
  <pickup-time-modal
    v-if="isPickupTimeSelection"
    v-bind="{
      closeModal,
      errorMessage,
      onContinue,
      selectedDate,
      selectedTime,
      setSelectedDate,
      setSelectedTime,
      toConfirmationScreen,
      vendorId: vendorId || activeVendor.id
    }"
  ></pickup-time-modal>
  <unavailable-items-modal
    v-else
    v-bind="{
      closeModal,
      onContinue,
      selectedTime,
      toSelectionScreen
    }"
  ></unavailable-items-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PickupTimeModal from "../pickup-time-modal/PickupTimeModal.vue";
import UnavailableItemsModal from "../unavailable-items-modal/UnavailableItemsModal.vue";

export const SCREEN_SELECT_TIME = "PickupTimeModal";
export const SCREEN_CONFIRM_SELECTION = "UnavailableItemsModal";

export default {
  name: "PickupTimeWrapper",
  components: { PickupTimeModal, UnavailableItemsModal },
  props: {
    vendorId: Number | null,
    errorMessage: String | null,
    goToNextStep: Function
  },
  data() {
    return {
      currentScreen: SCREEN_SELECT_TIME,
      selectedDate: null,
      selectedTime: null
    };
  },
  computed: {
    ...mapGetters({
      activeVendor: "vendor/getActiveVendor"
    }),
    isPickupTimeSelection() {
      return this.currentScreen === SCREEN_SELECT_TIME;
    }
  },
  methods: {
    setSelectedDate(date) {
      this.selectedDate = date;
    },
    setSelectedTime(time) {
      this.selectedTime = time;
    },
    toConfirmationScreen() {
      this.currentScreen = SCREEN_CONFIRM_SELECTION;
    },
    toSelectionScreen() {
      this.currentScreen = SCREEN_SELECT_TIME;
    },
    async onContinue() {
      if (this.vendorId && this.vendorId !== this.activeVendor?.id) {
        await this.clearShoppingCart();
      }

      this.setSelectedPickup({ time: this.selectedTime ?? null, id: this.vendorId ?? this.activeVendor.id });
      this.setActiveDayPart();
      this.goToNextStep?.();
      this.closeModal();
    },
    closeModal() {
      this.$modal.hide("PickupTimeWrapper");
    },

    ...mapActions({
      setSelectedPickup: "orderAhead/setSelectedPickup",
      setActiveDayPart: "vendor/setActiveDayPart",
      clearShoppingCart: "cart/clearShoppingCart"
    })
  }
};
</script>
